import React, { useState } from "react";

import useCurrentTeacher from "../../../../hooks/useCurrentTeacher";
import { Pencil } from 'lucide-react'
// import "./Experience.css";

const Socials = () => {
  const { teacher, fetchCurrentTeacher } = useCurrentTeacher();

  const [isModalOpen, setIsModalOpen] = useState(false);

  const [socials, setSocials] = useState({
    facebook: "",
    insta: "",
    linkedin: "",
    researchgate: "",
    ieee: "",
  });

  if (!teacher) return null;

  // Open modal and set existing values
  const openModal = () => {
    setSocials({
      facebook: teacher.socials.facebook || "",
      insta: teacher.socials.insta || "",
      linkedin: teacher.socials.linkedin || "",
      researchgate: teacher.socials.researchgate || "",
      ieee: teacher.socials.ieee || "",
    });
    setIsModalOpen(true);
  };

  const closeModal = () => setIsModalOpen(false);

  const handleSave = async () => {
    try {
      const updatedSocials = { ...socials };

      const formData = new FormData();
      formData.append("socials", JSON.stringify(updatedSocials));

      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}/teacher/${teacher.id}/`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "x-api-key": process.env.REACT_APP_X_API_KEY
          },
          body: formData,
        }
      );

      if (res.ok) {
        alert("Social links updated successfully!");
        fetchCurrentTeacher();
        closeModal();
      } else {
        const data = await res.json();
        alert(data.msg || "Failed to update socials");
      }
    } catch (err) {
      console.error(err);
      alert("Error updating socials");
    }
  };

  return (
   <div className="bg-white rounded-2xl p-2 md:p-6">
  {/* Header */}
  <div className="flex items-center justify-between mb-6">
    <div className="flex items-center gap-3">
      <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
        <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
        </svg>
      </div>
      <div>
        <h2 className="text-lg font-semibold text-gray-900">Your Socials</h2>
        <p className="text-sm text-gray-500 mt-0.5">Manage your social media links</p>
      </div>
    </div>
    <button
      className="w-10 h-10 bg-[#0f6abf] text-white rounded-xl flex items-center justify-center hover:bg-[#0a5ca8] transition-colors"
      onClick={openModal}
    >
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
      </svg>
    </button>
  </div>

  {/* Socials List */}
  <div className="space-y-3">
    {[
      { platform: "Facebook", value: teacher.socials.facebook, icon: "facebook" },
      { platform: "Instagram", value: teacher.socials.insta, icon: "instagram" },
      { platform: "LinkedIn", value: teacher.socials.linkedin, icon: "linkedin" },
      { platform: "ResearchGate", value: teacher.socials.researchgate, icon: "research" },
      { platform: "IEEE", value: teacher.socials.ieee, icon: "ieee" }
    ].map((social) => (
      <div key={social.platform} className="flex items-center gap-3 p-3 bg-gray-50 rounded-xl">
        <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center flex-shrink-0">
          {social.icon === "facebook" && (
            <svg className="w-5 h-5 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
              <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" />
            </svg>
          )}
          {social.icon === "instagram" && (
            <svg className="w-5 h-5 text-pink-600" fill="currentColor" viewBox="0 0 24 24">
              <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd" />
            </svg>
          )}
          {social.icon === "linkedin" && (
            <svg className="w-5 h-5 text-blue-700" fill="currentColor" viewBox="0 0 24 24">
              <path fillRule="evenodd" d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" clipRule="evenodd" />
            </svg>
          )}
          {social.icon === "research" && (
            <svg className="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
            </svg>
          )}
          {social.icon === "ieee" && (
            <svg className="w-5 h-5 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          )}
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-gray-900">{social.platform}</p>
          <p className="text-sm text-gray-500 truncate">{social.value || "Not provided"}</p>
        </div>
        {social.value && (
          <a 
            href={social.value} 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-sm text-[#0f6abf] hover:underline flex-shrink-0"
          >
            Visit
          </a>
        )}
      </div>
    ))}
  </div>

  {/* Modal */}
  {isModalOpen && (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl w-full max-w-md shadow-xl">
        <div className="p-6 border-b border-gray-100">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
              <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
              </svg>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900">Edit Social Links</h3>
              <p className="text-sm text-gray-500 mt-0.5">Update your social media profiles</p>
            </div>
          </div>
        </div>

        <div className="p-6 space-y-4">
          {[
            { key: "facebook", placeholder: "Facebook profile URL" },
            { key: "insta", placeholder: "Instagram profile URL" },
            { key: "linkedin", placeholder: "LinkedIn profile URL" },
            { key: "researchgate", placeholder: "ResearchGate profile URL" },
            { key: "ieee", placeholder: "IEEE profile URL" }
          ].map((item) => (
            <div key={item.key}>
              <label className="block text-sm font-medium text-gray-700 mb-2 capitalize">
                {item.key === "insta" ? "Instagram" : item.key}
              </label>
              <input
                type="text"
                placeholder={item.placeholder}
                value={socials[item.key]}
                onChange={(e) => setSocials({ ...socials, [item.key]: e.target.value })}
                className="w-full px-4 py-3 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
              />
            </div>
          ))}
        </div>

        <div className="px-6 py-4 bg-gray-50/50 border-t border-gray-100">
          <div className="flex items-center justify-end gap-3">
            <button
              onClick={closeModal}
              className="px-5 py-2.5 text-gray-700 font-medium rounded-xl hover:bg-gray-100 transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={handleSave}
              className="px-5 py-2.5 bg-[#0f6abf] text-white font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors"
            >
              Save Changes
            </button>
          </div>
        </div>
      </div>
    </div>
  )}
</div>
  );
};

export default Socials;
